import { render, staticRenderFns } from "./StockPickingLab.vue?vue&type=template&id=7518704b&scoped=true&"
import script from "./StockPickingLab.vue?vue&type=script&lang=js&"
export * from "./StockPickingLab.vue?vue&type=script&lang=js&"
import style0 from "./StockPickingLab.vue?vue&type=style&index=0&id=7518704b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7518704b",
  null
  
)

export default component.exports